module.exports = __webpack_public_path__ + "static/media/celeb-360-double-arrow.1b22f617.svg";